export default __webpack_public_path__ + "static/media/Shapes_26.72283fe8.png";